<template>
  <div :class="computedClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { WellVariant } from './types'

const props = withDefaults(defineProps<{
  variant?: WellVariant
  hasBorder?: boolean
}>(), {
  variant: 'default',
})

const computedVariantClasses = computed(() => {
  return [
    'rounded-lg p-4',
    {
      'bg-gray-50 border-gray-600': props.variant === 'default',
      'bg-primary-50 border-primary-600': props.variant === 'highlight',
    },
  ]
})

const computedClasses = computed(() => {
  return [
    'rounded-lg p-4',
    {
      border: props.hasBorder,
    },
    computedVariantClasses.value,
  ]
})
</script>
